import { Section } from '../builders/section_builder';
import { IModel } from 'core-ts-types';
import * as _4 from 'lodash4';

export type LinkedSectionModelEntry = Record<string, Section['_linked_sections']>;

export class LinkedSectionsModel implements IModel {
  private _linked_sections: LinkedSectionModelEntry = {};

  initialize() {
    this.clear();
  }

  clear(): LinkedSectionsModel {
    this._linked_sections = {};
    return this;
  }

  write(source: LinkedSectionModelEntry): LinkedSectionsModel {
    this._linked_sections = _4.merge(this._linked_sections, source);
    return this;
  }

  read(): LinkedSectionModelEntry {
    return this._linked_sections;
  }

  get(sectionId: number) {
    return this._linked_sections[sectionId];
  }

  update(source: any) {
    this._linked_sections = _4.merge(this._linked_sections, source);
    return this;
  }
}

angular.module('capability-ng-scheduler').service('ngLinkedSectionsModel', LinkedSectionsModel);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/sections/models/linked_sections_model.ts